module.exports = __webpack_public_path__ + "static/media/strongher17.937016ef.jpg";